// removed by extract-text-webpack-plugin
module.exports = {"headerRow":"TablaPendientes__headerRow___2r3wG","evenRow":"TablaPendientes__evenRow___2zv3I","oddRow":"TablaPendientes__oddRow___mybS5","headerColumn":"TablaPendientes__headerColumn___3Md5k","headerRowAPI":"TablaPendientes__headerRowAPI___1216p","evenRowAPI":"TablaPendientes__evenRowAPI___2ggJJ","oddRowAPI":"TablaPendientes__oddRowAPI___mrl7V","headerColumnAPI":"TablaPendientes__headerColumnAPI___3mi2T","celdaAPI":"TablaPendientes__celdaAPI___2AGFu","celdaAPILider":"TablaPendientes__celdaAPILider___3YwAA"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/admin/OperadoresPendientes/TablaPendientes.css
// module id = 1191
// module chunks = 0